import alert from "./alert/index"
import loading from "./loading/index"
import confirm from "./confirm/index"


const dialog = {
  alert,
  loading,
  confirm
}
export default dialog;
